import { Modal } from 'almanac-ui/Modal'
import { CreditCardForm, CreditCardFormProps } from './CreditCardForm'

interface CreditCardFormModalProps extends CreditCardFormProps {
  handleOutsidePress: () => void
}

export const CreditCardFormModal = (props: CreditCardFormModalProps) => {
  return (
    <Modal.Root onPressOutside={props.handleOutsidePress}>
      <CreditCardForm {...props} />
    </Modal.Root>
  )
}
